"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormalCharge = getFormalCharge;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the formal charge of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getFormalCharge(data) {
    const formalCharge = (0, getNumberProperties_1.getNumberProperties)(data, 'Formal Charge');
    return formalCharge;
}
//# sourceMappingURL=getFormalCharge.js.map